import globalActions from '@/actions'
const state = {
	config: null
}
const mutations = {
  update: (state, data) => {
    state.config = data
	globalActions.setGlobalState({
		config: state
	});
  }
}
const actions = {
	async get({
		commit
	}) {
		if (state.data == null) {
			const consoleConfig = await fetch('/config.json?t=' + new Date().valueOf());
			let json =  await consoleConfig.json()
			if(json.framework && json.framework.dev){
				try{
					const devConfig = await fetch('/dev.config.json?t=' + new Date().valueOf());
					let devJson =  await devConfig.json()
					for(let prop in devJson){
						json.apps[prop] = devJson[prop]
					}
					console.log("Loaded dev config",devJson);
				}catch(e){
					//console.log("Loaded dev ex",e);

				}
			}
			commit('update',json)
		}
		return state;
	},
}
export default {
	namespaced: true,
	mutations,
	state,
	actions
}
